import {
  Box,
  useTheme,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import Header from "../../components/Header";
import SendIcon from "@mui/icons-material/Send";
import { format } from "date-fns";
import { useDispatch } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import DataGridCustomToolbar from "../../components/DataGridCustomToolbar";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useGetMeetupListQuery } from "../../state/api";

const MeetUp = () => {
  const theme = useTheme();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [sort, setSort] = useState({});
  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [isDataFetched, setIsDataFetched] = useState(false);
  const [isUserDataFetched, setIsUserDataFetched] = useState(false);
  const [meetupUser, steMeetupUser] = useState([]);
  const { data, isLoading } = useGetMeetupListQuery();
  const [users, setUsers] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [dates, setDates] = useState({ fromDate: "", toDate: "" });
  const dispatch = useDispatch();
  const [noMeetupFound, setNoMeetupFound] = useState(false);
  // const uniqueUsers = users.reduce((acc, current) => {
  //   const x = acc.find((item) => item.senderName === current.senderName);
  //   if (!x) {
  //     return acc.concat([current]);
  //   } else {
  //     return acc;
  //   }
  // }, []);

  useEffect(() => {
    if (data && data.success) {
      const formattedMeetups = data.meetups.map((meetup) => ({
        ...meetup,
        date: new Date(meetup.date).toISOString().split("T")[0],
      }));
      setRowData(formattedMeetups);
    }
  }, [data]);

  let [filterData, setFilterData] = useState([]);

  const fetchData = async () => {
    try {
      const response = await axios.get("/meetup/list");
      setUsers(response.data.meetups);
      setIsDataFetched(true);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleOpen = () => {
    if (!isDataFetched) {
      fetchData();
    }
  };

  const fetchUserData = async () => {
    try {
      const response = await axios.get("/user/userFullname");
      // console.log("usernmae", response);
      steMeetupUser(response.data.profile);
      setIsUserDataFetched(true);
    } catch (error) {
      console.error("Error", error);
    }
  };

  const handleUserOpen = () => {
    if (!isUserDataFetched) {
      fetchUserData();
    }
  };

  const handleChange = (event, type) => {
    const value = event.target.value;
    if (value === "all") {
      setDates({ fromDate: "", toDate: "" });
      setFilterData({});
    } else {
      if (type === "fromDate" || type === "toDate") {
        setDates((prevDates) => ({
          ...prevDates,
          [type]: value,
        }));
        setFilterData((prevFilters) => ({
          ...prevFilters,
          [type]: value,
        }));
      } else {
        setFilterData((prevFilters) => ({
          ...prevFilters,
          [type]: value,
        }));
      }
    }
  };

  const handleSubmit = async () => {
    try {
      const params = {
        ...filterData,
      };
      if (dates.fromDate) params.fromDate = dates.fromDate;
      if (dates.toDate) params.toDate = dates.toDate;

      const response = await axios.get("/meetup/list", { params });
      setRowData(response.data.meetups);
    } catch (error) {
      console.error(error);
      toast.error("No Meet-Up Found");
    }
  };

  const columns = [
    {
      field: "type",
      headerName: "Title",
      flex: 0.5,
    },
    {
      field: "senderName",
      headerName: "Sender Name",
      flex: 0.5,
      renderCell: (params) => params.value || "N/A",
    },
    {
      field: "receiverName",
      headerName: "Receiver Name",
      flex: 0.5,
      renderCell: (params) => params.value || "N/A",
    },
    {
      field: "groupName",
      headerName: "Group-Name",
      flex: 0.5,
      // valueGetter: (params) => params.row.groupName || "N/A",
      renderCell: (params) => params.value || "N/A",
    },
    {
      field: "location",
      headerName: "Location",
      flex: 0.5,
    },
    {
      field: "date",
      headerName: "Date",
      flex: 0.5,
    },
    {
      field: "startTime",
      headerName: "Start Time",
      flex: 0.5,
    },
    {
      field: "endTime",
      headerName: "End Time",
      flex: 0.5,
    },
    {
      field: "status",
      headerName: "Status",
      flex: 0.5,
    },
    {
      field: "createdAt",
      headerName: "CreatedAt",
      flex: 0.5,
      renderCell: (params) => {
        const date = new Date(params.value);
        return format(date, "yyyy-MM-dd");
      },
    },
    {
      field: "updatedAt",
      headerName: "UpdatedAt",
      flex: 0.5,
      renderCell: (params) => {
        const date = new Date(params.value);
        return format(date, "yyyy-MM-dd");
      },
    },
  ];

  return (
    <Box m="1.5rem 2.5rem">
      <ToastContainer />
      <Header title="MEET-UP" />
      <Box display="flex" flexWrap="wrap" alignItems="flex-end">
        <FormControl variant="standard" sx={{ m: 2, minWidth: 200 }}>
          <InputLabel id="select-standard-label">Sender</InputLabel>
          <Select
            id="select-standard"
            onChange={(e) => handleChange(e, "senderId")}
            onOpen={handleUserOpen}
            label="Sender"
          >
            <MenuItem value="all">All</MenuItem>
            {isUserDataFetched &&
              meetupUser.map((user) => (
                <MenuItem key={user._id} value={user._id}>
                  {user.fullname}
                </MenuItem>
              ))}
          </Select>
        </FormControl>{" "}
        <FormControl variant="standard" sx={{ m: 2, minWidth: 200 }}>
          <InputLabel id="select-standard-label">Receiver</InputLabel>
          <Select
            id="select-standard"
            onChange={(e) => handleChange(e, "receiverId")}
            onOpen={handleUserOpen}
            label="Receiver"
          >
            <MenuItem value="all">All</MenuItem>
            {isUserDataFetched &&
              meetupUser.map((user) => (
                <MenuItem key={user._id} value={user._id}>
                  {user.fullname}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
        <FormControl variant="standard" sx={{ m: 2, minWidth: 200 }}>
          <InputLabel id="select-standard-label">Status</InputLabel>
          <Select
            id="select-standard"
            onChange={(e) => handleChange(e, "status")}
            label="User"
          >
            <MenuItem value="all">All</MenuItem>
            <MenuItem value="pending">Pending</MenuItem>
            <MenuItem value="accepted">Accepted</MenuItem>
            <MenuItem value="countered">Countered</MenuItem>
            <MenuItem value="rejected">Rejected</MenuItem>
            <MenuItem value="failed">Failed</MenuItem>
            {isDataFetched &&
              users.map((user) => (
                <MenuItem key={user.status} value={user.status}>
                  {user.status}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
        <FormControl variant="standard" sx={{ m: 2, minWidth: 200 }}>
          <div>
            <TextField
              id="from-date"
              label="From"
              type="date"
              value={dates.fromDate}
              onChange={(e) => handleChange(e, "fromDate")}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              id="to-date"
              label="To"
              type="date"
              value={dates.toDate}
              onChange={(e) => handleChange(e, "toDate")}
              InputLabelProps={{
                shrink: true,
              }}
              sx={{ marginLeft: 2 }}
            />
          </div>
        </FormControl>
        <FormControl variant="standard" sx={{ m: 2, minWidth: 100 }}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            startIcon={<SendIcon />}
            onClick={handleSubmit}
          >
            Filter
          </Button>
        </FormControl>
      </Box>

      <Box
        mt="40px"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: theme.palette.primary.success,
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderTop: "none",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${theme.palette.secondary[200]} !important`,
          },
        }}
      >
        <DataGrid
          loading={isLoading || !data}
          getRowId={(row) => row._id}
          rows={rowData}
          columns={columns}
          autoHeight
          disableColumnMenu
          disableColumnSelector
          hideFooter
          rowCount={(rowData && rowData.total) || 0}
          rowsPerPageOptions={[20, 50, 100]}
          pagination
          page={page}
          pageSize={pageSize}
          paginationMode="server"
          sortingMode="server"
          onPageChange={(newPage) => setPage(newPage)}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          onSortModelChange={(newSortModel) => setSort(...newSortModel)}
          components={{
            Toolbar: DataGridCustomToolbar,
          }}
          componentsProps={{
            toolbar: {
              searchInput,
              setSearchInput,
              setSearch,
              columns,
              rowData,
            },
          }}
        />
      </Box>
    </Box>
  );
};
export default MeetUp;
